export default function TBULogo({ height = 80, color = "#FFF9F9" }: { height?: number; color?: string }) {
  const width = height * (45.0516 / 47);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 45.0516 47"
      width={width}
      height={height}
      style={{ display: "block" }}
      aria-label="TBU Logo"
    >
      <path d="M22.8137 40.1478L23.3897 39.9886V9.23164L21.6465 8.76172V39.9886L22.2301 40.1478C22.4196 40.2008 22.6242 40.2008 22.8137 40.1478Z" fill={color} />
      <path d="M27.1642 6.23798L17.9023 3.75195V12.4682L13.9004 11.4147V37.0859C13.9004 37.5407 14.2036 37.9348 14.6432 38.0561L15.6436 38.3289V13.6809L19.6455 14.7344V6.02576L25.421 7.57952V25.1788L29.3926 24.1101V38.3365L30.3931 38.0561C30.8251 37.9348 31.1358 37.5331 31.1358 37.0859V21.8363L27.1642 22.905V6.23798Z" fill={color} />
      <path d="M17.7812 38.9273L19.5245 39.4048V16.9548L17.7812 16.4849V38.9273Z" fill={color} />
      <path d="M25.5117 39.4053L27.255 38.9278V26.8994L25.5117 27.3618V39.4053Z" fill={color} />
      <path d="M43.3084 45.2414H1.74325V22.4503H4.41876V20.707H0V46.9846H45.0516V20.707H40.6253V22.4503H43.3084V45.2414Z" fill={color} />
      <path d="M37.3813 41.1712L23.6475 44.9608C22.9199 45.1655 22.1468 45.1655 21.4116 44.9608L7.67782 41.1787V17.319L12.1572 18.5165V16.7126L5.93457 15.0527V42.5051L21.5101 46.8178C22.1771 46.9997 22.882 47.0073 23.5566 46.8178L39.1321 42.5203V15.0679L28.8015 17.8344V19.6382L37.3889 17.3417V41.1787L37.3813 41.1712Z" fill={color} />
      <path d="M23.3975 0.46992L21.6543 0V6.4955H23.3975V0.46992Z" fill={color} />
    </svg>
  );
}
